import './styles.scss';

import React from 'react';
import { ContentModule } from '@nhl/nhl-react-ui/lib/ContentModule';

import FooterMenu from './components/FooterMenu';
import TemplateKeys from '../../../utils/contentModuleTemplateKeys';

const Footer = ({authenticated = true}) => (
    <footer>
        { authenticated
            ?   <FooterMenu />
            :   null
        }

        { authenticated
            ?   <div className="footer-modules">
                    <ContentModule templateKey={TemplateKeys.FOOTER} sequence={1} />
                    <ContentModule templateKey={TemplateKeys.FOOTER} sequence={2} />
                </div>
            :   null
        }

        <div className="copyright">
            <img src="https://assets.nhle.com/logos/nhl/svg/NHL_dark.svg" alt="National Hockey League"/>
            <div>
                {
                    `NHL.com is the official web site of the National Hockey League. NHL, the NHL Shield,
                    the word mark and image of the Stanley Cup, the Stanley Cup Playoffs logo, the Stanley Cup Final logo,
                    Center Ice name and logo, NHL Conference logos, NHL Winter Classic name,
                    and The Biggest Assist Happens Off The Ice are registered trademarks and Vintage Hockey word mark and logo,
                    The Game Lives Where You Do, NHL Winter Classic logo, NHL Heritage Classic name and logo,
                    NHL Stadium Series name and logo, NHL All-Star logo, NHL Face-Off name and logo, NHL. TV, NHL Premium,
                    NHL After Dark, NHL GameCenter, NHL GameCenter LIVE, NHL Network name and logo, NHL Tonight name and logo,
                    On The Fly, NHL Awards name and logo, NHL Draft name and logo, Hockey Fights Cancer, Because It's The Cup,
                    NHL Green name and logo, NHL Vault, Hockey Is For Everyone, NHL Thanksgiving Showdown name and logo,
                    NHL Centennial Classic name and logo, NHL Centennial Season logo, NHL100 Classic name and logo,
                    NHL Global Series name and logo, NHL China Games name and logo, and Don't Miss A Moment are trademarks of the National Hockey League.
                    All NHL logos and marks and NHL team logos and marks depicted herein are the property of the NHL and the respective
                    teams and may not be reproduced without the prior written consent of NHL Enterprises, L.P.
                    © NHL ${new Date().getFullYear()}. All Rights Reserved. All NHL team jerseys customized with NHL players' names and numbers are officially licensed by the NHL and the NHLPA.
                    The Zamboni word mark and configuration of the Zamboni ice resurfacing machine are registered trademarks of Frank J. Zamboni & Co., Inc.
                    © Frank J. Zamboni & Co., Inc. ${new Date().getFullYear()}. All Rights Reserved. Any other third party trademarks or copyrights are property of their respective owners. All rights reserved.`
                }
            </div>
        </div>

    </footer>
);

export default Footer
